import { FuseNavigation } from '@fuse/types';

export const navigation: FuseNavigation[] = [
    {
        id: 'applications',
        title: 'UYGULAMALAR',
        translate: 'UYGULAMALAR',
        type: 'group',
        icon: 'apps',
        children: [
            {
                id: 'dashboard',
                title: 'Dashboard',
                type: 'item',
                icon: 'dashboard',
                url:'/apps/dashboard'
            },
            {
                id: 'setup',
                title: 'Kurulum',
                type: 'collapsable',
                icon: 'devices_other',
                children: [
                    {
                        id: 'device',
                        title: 'Cihaz',
                        type: 'item',
                        url: '/apps/devices',
                    },
                    {
                        id: 'firmware',
                        title: 'Firmware',
                        type: 'item',
                        url: '/apps/firmware',
                    },
                    {
                        id: 'car',
                        title: 'Araç',
                        type: 'item',
                        url: '/apps/car',
                    },
                    {
                        id: 'container',
                        title: 'Konteyner',
                        type: 'item',
                        url: '/apps/container',
                    }
                ]
            },
            {
                id: 'administration',
                title: 'Yönetim',
                type: 'collapsable',
                icon: 'delete',
                children: [
                    {
                        id: 'zone',
                        title: 'Bölge',
                        type: 'item',
                        url: '/apps/zone',
                    }
                ]
            },
            {
                id:'user',
                title:'Kullanıcı',
                type:'item',
                icon:'person',
                url:'/apps/user'
            },
            {
                id: 'logs',
                title: 'Loglar',
                type: 'collapsable',
                icon: 'archive',
                children: [
                    {
                        id: 'dlog',
                        title: 'Cihaz Verileri',
                        type: 'item',
                        url: '/apps/device-log',
                    },
                    {
                        id: 'qlog',
                        title: 'Sorgu Logları',
                        type: 'item',
                        url: '/apps/query-log',
                    },
                    {
                        id: 'slog',
                        title: 'Oturum Logları',
                        type: 'item',
                        url: '/apps/session-log',
                    }
                ]
            },
            {
                id: 'locations',
                title: 'Harita Servisleri',
                type: 'collapsable',
                icon: 'map',
                children: [
                    {
                        id: 'admin',
                        title: 'Konum Bilgileri',
                        type: 'item',
                        url: '/apps/map',
                    },
                ]
            },
            
        ]
    }
];
